import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const PreviewIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf1c5'}</MuiIcon>
    );
}
